import { API, PM_API } from "@/utils/http"

const SELLER_SYNCS_URL = "/v2/seller/synchronizations"

export default {
  async getSynchronizations() {
    const response = await API.get(SELLER_SYNCS_URL)

    return response
  },

  async getSynchronization(synchronizationUuid) {
    const response = await API.get(`${SELLER_SYNCS_URL}/${synchronizationUuid}`)

    return response
  },

  async getDraftsMeta(synchronizationUuid) {
    const response = await API.get(`${SELLER_SYNCS_URL}/${synchronizationUuid}/drafts/meta`)

    return response
  },

  async getOffersIsSellingInSync(uuid) {
    const response = await API.get("/v2/seller/catalog/offers", {
      params: {
        external_source_id: uuid,
        is_selling: true,
        limit: 0
      }
    })

    return response
  },

  async getTask(synchronizationUuid) {
    const response = await API.get(`${SELLER_SYNCS_URL}/${synchronizationUuid}/task`)

    return response
  },

  async verifySynchronization(payload) {
    const response = await API.post(`${SELLER_SYNCS_URL}/verify`, payload)

    return response
  },

  async createSynchronization(data) {
    const response = await API.post(SELLER_SYNCS_URL, data)

    return response
  },

  async updateSynchronization({ data, uuid }) {
    const response = await API.put(`${SELLER_SYNCS_URL}/${uuid}`, data)

    return response
  },

  async triggerSynchronization(uuid) {
    const response = await API.post(`${SELLER_SYNCS_URL}/${uuid}/trigger`)

    return response
  },

  async deleteSynchronization(uuid) {
    const response = await API.delete(`${SELLER_SYNCS_URL}/${uuid}`)

    return response
  },

  /**
   * @param {object} [params]
   * @param {number} [params.pageSize]
   * @param {number} [params.page]
   * @param {object} [params.query]
   * @param {string} [params.uuid]
   * @param {AbortSignal} [params.signal]
   */
  async getDrafts({ pageSize = 10, page = 1, query = {}, uuid, signal } = {}) {
    const paginationQuery = {
      limit: pageSize,
      offset: (page - 1) * pageSize
    }
    const params = {
      ...query,
      ...paginationQuery
    }
    const response = await API.get(`${SELLER_SYNCS_URL}/${uuid}/drafts`, {
      params,
      signal
    })

    return response
  },

  async updateDraft({ payload, draftUuid, synchronizationUuid }) {
    const response = await API.put(
      `${SELLER_SYNCS_URL}/${synchronizationUuid}/drafts/${draftUuid}`,
      payload
    )

    return response
  },

  async updateDrafts({ payload, synchronizationUuid }) {
    const response = await API.put(
      `${SELLER_SYNCS_URL}/${synchronizationUuid}/drafts/bulk/approve`,
      payload
    )

    return response
  },

  async trackTask({ taskUuid, synchronizationUuid }) {
    const response = await API.get(
      `${SELLER_SYNCS_URL}/${synchronizationUuid}/drafts/bulk/tasks/${taskUuid}`
    )

    return response
  },

  async getXmlWithErrors(synchronizationUuid, file_format) {
    const response = await API.post(`${SELLER_SYNCS_URL}/${synchronizationUuid}/report`, {
      file_format
    })

    return response.data
  },

  async getReportState({ synchronizationUuid, taskUuid }) {
    const response = await API.get(`${SELLER_SYNCS_URL}/${synchronizationUuid}/report/${taskUuid}`)

    return response.data
  },

  async downloadCategoriesHierarchy() {
    const response = await API.post(`/v2/seller/catalog/categories/export`)

    return response
  },

  async checkTaskResults(taskId) {
    const response = await API.get(`/v2/seller/catalog/tasks/${taskId}`)

    return response.data
  },

  async getProductTypesRules(categoryCodes) {
    const params = new URLSearchParams(categoryCodes.map((code) => ["category_codes", code]))
    const response = await PM_API.post(`/xml-sync/product-types/?${params}`)

    return response
  },

  async getAttributesRules(categoryCodes, fileFormat) {
    const params = new URLSearchParams(categoryCodes.map((code) => ["category_codes", code]))
    params.set("file_format", fileFormat)
    const response = await PM_API.post(`/xml-sync/attributes/?${params}`)

    return response
  },

  async getAttributeValuesRules(categoryCodes, fileFormat) {
    const params = new URLSearchParams(categoryCodes.map((code) => ["category_codes", code]))
    params.set("file_format", fileFormat)
    const response = await PM_API.post(`/xml-sync/attribute-values/?${params}`)

    return response
  },

  async checkCategorySyncRulesTask(taskId) {
    const response = await PM_API.get(`/xml-sync/results/${taskId}/`)

    return response.data
  }
}
